import TextPressure from "./TextPressure";

function Work() {
  return (
    <section id="work" className="work">
      <div className="container">
        <h1 className="section-heading">
        <span>
          <TextPressure text="Our " textColor="#000000" />
        </span>
          <TextPressure text="Works" textColor="#00d9ff" />
        </h1>
        <p>We provide high standar clean website for your business solutions</p>

        <div className="card-wrapper">
          <div className="card">
            <h2><u>Artificial Intelligence Intern - Acmegrade</u></h2>
            <p>From 10/06/2025 to 10/08/2025</p>
            <ul className="des">
              <li>Worked on fundamentals of AI and Python projects.</li>
              <li>Developed basic machine learning models using scikit-learn.</li>
            </ul>
          </div>

           <div class="card">
                
                <h2><u>Development Intern - Dyizan</u></h2>
                <p>From 23/06/2025 to 07/08/2025</p>
                <ul class="des">
                    <li>Created a responsive portfolio website using HTML, CSS, and JavaScript.</li>
                    <li>Created a Simple Online Bookstore website using HTML, CSS, and JavaScript. </li>
                    <li>Created a Local Event website using HTML, CSS, and JavaScript. </li>
                </ul>
            </div>

            <div class="card">
                
                <h2><u>Frontend Development Intern - Code Alpha</u></h2>
                <p>From 01/07/2025 to 30/07/2025</p>
                <ul class="des">
                    <li>Created a image gallery website using HTML, CSS, and JavaScript.</li>
                    <li>Created a calculator website using HTML, CSS, and JavaScript.</li>
                    <li>Created a responsive portfolio website using HTML, CSS, and JavaScript.</li>
                </ul>
            </div>

            <div class="card">
    
                <h2><u>Web Development Intern - CodSoft</u></h2>
                <p>From 25/06/2025 to 25/07/2025</p>
                <ul class="des">
                    <li>Created a landing page website using HTML, CSS, and JavaScript.</li>
                    <li>Created a calculator website using HTML, CSS, and JavaScript.</li>
                    <li>Created a responsive portfolio website using HTML, CSS, and JavaScript.</li>
                </ul>
            </div>
        </div>
      </div>
    </section>
  );
}

export default Work;
